package com.essntl.features.message.domain.model

data class WhapiMessageAction(
    val target: String,
    val type: String,
    val emoji: String?,
) {
    companion object {
        val empty =
            WhapiMessageAction(
                target = "",
                type = "",
                emoji = null,
            )
    }
}
